/**
 * List of available controls consumers may choose from. Controls are not
 * customizable by consumers at the moment. This is intentional to maintain
 * rendering consistency of controls across Singularity and discourage subtle
 * variations. If slight variations (icons, labels, etc) becomes necessary,
 * revisit this and consider exposing configurable options.
 *
 * Order of controls are ordered alphabetically by their `name` value. When
 * adding new controls, please insert them in their proper locations.
 *
 * @type {Array}
 * @param {string} name Unique identifier for the control.
 * @param {string} label Displayable text of the control.
 * @param {string} icon Name of icon font glyph to show next to label.
 */
export default [{
  name: 'add-activities',
  icon: 'plus',
  label: 'Add activities'
}, {
  name: 'add-to-report',
  icon: 'plus',
  label: 'Add to report'
}, {
  name: 'go-back',
  label: 'Go back'
}, {
  name: 'buy-users',
  label: 'Purchase user licenses'
}, {
  name: 'cancel',
  label: 'Cancel'
}, {
  name: 'change-activities',
  icon: 'edit',
  label: 'Change activities'
}, {
  name: 'configure',
  icon: 'gear',
  label: 'Edit'
}, {
  name: 'continue',
  label: 'Continue'
}, {
  name: 'copy',
  icon: 'copy',
  label: 'Copy'
}, {
  name: 'create',
  icon: 'plus',
  label: 'Create'
}, {
  name: 'register',
  icon: 'plus',
  label: 'Register'
}, {
  name: 'clear-responses',
  icon: 'archive',
  label: 'Clear responses'
}, {
  name: 'contact-sales',
  label: 'Contact sales'
}, {
  name: 'create-report',
  icon: 'report-add',
  label: 'Create report'
}, {
  name: 'delete',
  icon: 'trash',
  label: 'Delete'
}, {
  name: 'delete-folder',
  icon: 'trash',
  label: 'Delete folder'
}, {
  name: 'delete-report',
  icon: 'trash',
  label: 'Delete report'
}, {
  name: 'download',
  icon: 'download',
  label: 'Download'
}, {
  name: 'feedback',
  label: 'Send feedback'
}, {
  name: 'insert-slide',
  icon: 'insert',
  label: 'Insert slides'
}, {
  name: 'send-invites',
  label: 'Send invitations'
}, {
  name: 'logout',
  icon: 'move',
  label: 'Logout'
}, {
  name: 'lock',
  icon: 'lock',
  label: 'Lock'
}, {
  name: 'moderate',
  icon: 'gavel',
  label: 'Moderate'
}, {
  name: 'more',
  icon: 'ellipsis',
  label: 'More'
}, {
  name: 'move',
  icon: 'folder-move',
  label: 'Move'
}, {
  name: 'new-activity',
  icon: 'plus',
  label: 'New activity'
}, {
  name: 'new-folder',
  icon: 'folder-closed',
  label: 'New folder'
}, {
  name: 'next',
  icon: 'arrow-right',
  label: 'Next'
}, {
  name: 'opt-out-beta',
  label: 'Opt-out beta'
}, {
  name: 'opt-out-send',
  label: 'Opt-out & send'
}, {
  name: 'present',
  icon: 'play',
  label: 'Present'
}, {
  name: 'previous',
  icon: 'arrow-left',
  label: 'Previous'
}, {
  name: 'rename-folder',
  icon: 'edit',
  label: 'Rename folder'
}, {
  name: 'reorder-activities',
  icon: 'reorder',
  label: 'Reorder activities'
}, {
  name: 'restore',
  icon: 'folder-move',
  label: 'Restore to ...'
}, {
  name: 'save',
  label: 'Save'
}, {
  name: 'select',
  icon: 'checkmark',
  label: 'Select'
}, {
  name: 'select-all',
  icon: 'checkmark',
  label: 'Select all'
}, {
  name: 'search-field',
  label: 'Search'
}, {
  name: 'search',
  icon: 'search',
  label: 'Search'
}, {
  name: 'send-message',
  label: 'Send message'
}, {
  name: 'skip',
  label: 'Skip'
}, {
  name: 'start-using',
  label: 'Get started'
}, {
  name: 'stop-presenting',
  icon: 'stop',
  label: 'Stop presenting'
}, {
  name: 'support-center',
  label: 'Visit support center'
}, {
  name: 'trash',
  icon: 'trash',
  label: 'Move to trash'
}, {
  name: 'unlock',
  icon: 'unlock',
  label: 'Unlock'
}, {
  name: 'update',
  icon: 'restart',
  label: 'Update'
}, {
  name: 'visual-settings',
  icon: 'visual-settings',
  label: 'Visual settings'
}]
